// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__egzDb","footer":"ReportModalFilter_footer__1UUGa"};